import { create } from "zustand";


export const useMessageCountThread = create((set) => ({
  messageThreadCount: {}, 
  

  addMessageThreadCount: (threadId: number, count: number) =>
    set((state:any) => ({
      messageThreadCount: {
        ...state.messageThreadCount,
        [threadId]: count, 
      },
    })),
}));